export const colors = {
  reset: '\x1b[0m',
  bold: '\x1b[1m',
  green: '\x1b[32m',
  red: '\x1b[31m',
  cyan: '\x1b[36m',
  yellow: '\x1b[33m',
  dim: '\x1b[2m',
};

/** Production distribution dashboard — agents use this when CFM_DASHBOARD_API is unset. */
export const DEFAULT_DISTRIBUTION_DASHBOARD_URL =
  'https://distribution-dashboard-three.vercel.app';
